function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export default {
  setAttributes: function setAttributes(state, attributes) {
    state.attributes = attributes;
  },
  SET_GROUPS_BY_ORG: function SET_GROUPS_BY_ORG(state, data) {
    state.groupsByOrg = data;
    if (data && data.company_code) {
      state.groupsByOrgCache = _objectSpread(_objectSpread({}, state.groupsByOrgCache), {}, _defineProperty({}, data.company_code, data));
    }
  },
  SET_GROUPS_BY_ORG_CACHE: function SET_GROUPS_BY_ORG_CACHE(state, data) {
    if (!data || !data.company_code) return;
    state.groupsByOrgCache = _objectSpread(_objectSpread({}, state.groupsByOrgCache), {}, _defineProperty({}, data.company_code, data));
  },
  addAtribute: function addAtribute(state, attribute) {
    var a = {
      nombre: attribute.nombre,
      tabla: attribute.tabla,
      dataset: attribute.dataset,
      proyecto: attribute.proyecto,
      descripcion: ' ',
      filters: attribute.filters ? attribute.filters : {},
      categoria: attribute.categoria,
      tipo_dato: attribute.tipo_dato,
      no_nulo: attribute.no_nulo,
      status: attribute.status
    };
    state.attributes.push(a);
  },
  removeAtribute: function removeAtribute(state, attribute) {
    var a = {
      nombre: attribute.nombre,
      tabla: attribute.tabla,
      dataset: attribute.dataset,
      proyecto: attribute.proyecto,
      descripcion: ' ',
      filters: attribute.filters ? attribute.filters : {},
      categoria: attribute.categoria,
      tipo_dato: attribute.tipo_dato,
      no_nulo: attribute.no_nulo,
      status: attribute.status
    };
    state.attributes.pop(a);
  },
  setUseCaseRequest: function setUseCaseRequest(state, value) {
    state.useCaseRequest = value;
  },
  updateUseCaseRequest: function updateUseCaseRequest(state, _ref) {
    var property = _ref.property,
      value = _ref.value;
    if (!state.useCaseRequest) {
      state.useCaseRequest = {};
    }
    state.useCaseRequest = _objectSpread(_objectSpread({}, state.useCaseRequest), {}, _defineProperty({}, property, value));
  },
  setCompanyAbrevs: function setCompanyAbrevs(state, payload) {
    state.companyAbrevs = payload;
  },
  setLabelCatalog: function setLabelCatalog(state, payload) {
    state.labelCatalog = payload;
  },
  setStatusLogType: function setStatusLogType(state, payload) {
    state.statusLogTypes = payload;
  },
  setAttributeSourcesCatalog: function setAttributeSourcesCatalog(state, payload) {
    state.attributeSourcesCatalog = payload;
  },
  setSolicitudeTypes: function setSolicitudeTypes(state, payload) {
    state.solicitudeTypes = payload;
  },
  setBusinessUserServiceAccounts: function setBusinessUserServiceAccounts(state, payload) {
    state.businessUserServiceAccounts = payload;
  },
  setUserNotificationsnew: function setUserNotificationsnew(state, payload) {
    state.notificaciones_usuarios = payload;
  },
  addNotificationNew: function addNotificationNew(state, notification) {
    state.notificaciones_usuarios.push(notification);
  },
  setFlagCustomExpirationSbx: function setFlagCustomExpirationSbx(state, data) {
    state.flagCustomExpirationSbx = data;
  },
  setOrganizations: function setOrganizations(state, list) {
    state.organizations = list || [];
  },
  setOrgGroupCounts: function setOrgGroupCounts(state, counts) {
    state.orgGroupCounts = counts || {};
  }
};